import { kennzeileTeile } from '../project-labels'

/**
 * Die Kennzeile einer Position („1 PA Treppe mit Podest") zum Anzeigen: Menge und
 * Einheit stehen immer in normaler Schrift, nur die Bezeichnung übernimmt die
 * Schriftstärke der Umgebung (Auftraggeber 19.9.2026).
 */
export function Kennzeile({ position }: { position: Parameters<typeof kennzeileTeile>[0] }) {
  const { menge, bezeichnung } = kennzeileTeile(position)
  return (
    <>
      {menge && <span className="font-normal">{menge} </span>}
      {bezeichnung}
    </>
  )
}
